import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { Observable } from 'rxjs';
import { SharedService } from './services/shared.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(private _shared: SharedService) {}

  canActivate(): Observable<boolean> | Promise<boolean> | boolean {
    if (this._shared.isLoggednIn()) {
      return true;
    }
    window.open(window.location.origin + '/#/login/', '_parent');
    return false;
  }
}
